import React, { useState } from "react";
import { Button, ModalBody } from "reactstrap";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import CloudStorage from "../../../../../../../CloudStorage/CloudStorage";
import { useDispatch } from "react-redux";
import LoginLoaderButton from "../../../../../../Common/Loader/LoginLoaderButton";
import { approveSubmissionContest } from "../../../../../../../redux/contest/action";

export default function AcceptDocumentModel({ setModelaccept, pd, posts }) {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    // Yup validation schema (if needed in the future)
    const validationSchema = Yup.object().shape({});

    const handleSubmit = () => {
        setLoading(true);
        const data = {
            type: "2",
            id: pd?.id,
            status: "15",
            post_id: posts?.id,

        };
        dispatch(approveSubmissionContest(data, setLoading));
        setModelaccept(false)
    };

    return (
        <Formik
            initialValues={{}}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
        >
            {() => (
                <>
                    <div className ="add-task">
                        <h6>Accept Documents and Files</h6>
                        <button
                            type="button"
                            onClick={() => setModelaccept((state) => !state)}
                            className ="btn close-button"
                        >
                            <img
                                src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
                                alt="Close"
                            />
                        </button>
                    </div>
                    <ModalBody>
                        <p>
                            Are you sure you are accepting all documents and files?
                            After this, there will be no change requests applicable,
                            so please check thoroughly and complete this action only if you are 100% sure.
                        </p>
                    </ModalBody>
                    <div className ="modal-footer" style={{ marginBottom: 10 }}>
                        <Button
                            disabled={loading}
                            onClick={() => setModelaccept((state) => !state)}
                            className ="btn"
                            style={{ background: "#fff", color: "black", border: "2px solid", margin: 10 }}
                            type="button"
                        >
                            Cancel
                        </Button>
                    </div>
                    <div className ="modal-footer" style={{ marginBottom: 10 }}>
                        <Button
                            disabled={loading}
                            type="submit"
                            className ="btn"
                            onClick={() => { handleSubmit() }}
                        >
                            {loading ? <LoginLoaderButton /> : "YES"}
                        </Button>
                    </div>
                </>
            )
            }
        </Formik >
    );
}
